const state = {
  user: null,
  fbUser: null,
  loggingOut: false,
  bookmarks: [],
}

const mutations = {
  clear(state) {
    state.user = null
    state.fbUser = null
    state.loggingOut = false
    state.bookmarks = []
  },
  setUser(state, payload) {
    state.user = payload
  },
  setFbUser(state, payload) {
    state.fbUser = payload
  },
  setLoggingOut(state, payload) {
    state.loggingOut = payload
  },
  setBookmarks(state, payload) {
    state.bookmarks = payload
  },
}

export default {
  namespaced: true,
  state,
  mutations,
}